const getBaseDomain = () => window.location.host.replace(/(.+\.)?((.+\.)shootsta\.com|localhost)(:\d+)?$/, '$2$4');

export default getBaseDomain;
